"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const map_component_1 = require("../map.component");
const map_service_1 = require("../../../commons/map.service");
const router_1 = require("@angular/router");
const material_1 = require("@angular/material");
const AppBaseComponent_1 = require("../../../commons/AppBaseComponent");
const app_service_1 = require("../../../commons/app.service");
const _4d_mapper_1 = require("4d-mapper");
const application_events_service_1 = require("../../../xs/services/events/application-events.service");
const Cesium = window.Cesium;
class LockCameraComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, router, snackBar, dialog, mapService, mapComp, applicationEvents) {
        super(service, router, snackBar, dialog, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.mapService = mapService;
        this.mapComp = mapComp;
    }
    lock() {
        if (this.mapComp && this.mapComp.refPin && this.mapComp.refPin.position) {
            try {
                if (this.mapService.newAnnotation) {
                    this.mapService.flyTo(this.mapService.newAnnotation);
                    this.mapService.viewer.trackedEntity = this.mapService.helper.getCesiumObjectFor(this.mapService.newAnnotation).pin;
                }
                else {
                    this.mapService.flyToRefPin(this.mapComp.refPin);
                    this.mapService.viewer.trackedEntity = this.mapComp.refPin;
                }
                this.mapComp.cameraLocked = true;
            }
            catch (e) {
                console.log(e);
            }
        }
        else {
            this.openSnackBarWarn('MAP.CAMERA_CLICK');
        }
    }
    unlock() {
        this.mapComp.cameraLocked = false;
        this.mapService.viewer.trackedEntity = undefined;
    }
    ngOnDestroy() {
    }
}
exports.LockCameraComponent = LockCameraComponent;
